import { createGlobalStyle, css } from "styled-components";
import lovelo from "vendor/fonts/Lovelo.otf";
import viktor from "vendor/fonts/Viktor.otf";
import catamaranBold from "vendor/fonts/catamaran-extrabold-webfont.woff";
import catamaranBold2 from "vendor/fonts/catamaran-extrabold-webfont.woff2";
import notosansBold from "vendor/fonts/notosans-bold-webfont.woff";
import notosansBold2 from "vendor/fonts/notosans-bold-webfont.woff2";
import notosansRegular from "vendor/fonts/notosans-regular-webfont.woff";
import notosansRegular2 from "vendor/fonts/notosans-regular-webfont.woff2";
import opensansextraboldwebfont from "vendor/fonts/opensans-extrabold-webfont.woff";
import opensansextraboldwebfont2 from "vendor/fonts/opensans-extrabold-webfont.woff2";
import { media } from "utils/style-utils";

export const colors = {
  LIGHT_GRAY: "#E7EBEC",
  LIGHTER_GRAY: "#E1E7EA",
  LIGHTEST_GRAY: "#F7F9FB",
  MEDIUM_GRAY: "#688190",
  GRAY: "#E4EBF0",
  BODY: "#36474F",
  MAIN_COLOR: "#E70072",
  BODY_BACKGROUND: "#EFF4F7",
  LIGHT_BLUE: "#F2F8FF",
  WHITE: "#FFFFFF",
  GREEN: "#01FFD6",
  LIGHT_GREEN: "#0CFF00",
  RED: "#E50038",
  // Danger/destructive semantics — foreground + tint background for error
  // banners and destructive buttons (e.g. the /admin delete action).
  DANGER_FG: "#b00020",
  DANGER_BG: "#fdecef",
  // Positive/online status semantics — e.g. the /admin device online dot.
  STATUS_ONLINE: "#1b7f3b",
  MENU: "#131B38",
  MENU_LINK: "#91ADBA",
  DARK: "#183748",
  BUTTON_BG: "linear-gradient(135deg, #DF33D2 0%, #FF406A 100%)",
  BORDER_BTN: "#007AFF 1px solid",
  BORDER_NONE: "none",
  LIGHT_MAIN_COLOR: "#ef9dca",

  ACTIVE_COLOR: "#01FFD6",
  DARK_GRAY: "#2d2d2d",
  IRONSIDE_GREY: "#666666",
  MOUNTAIN_MIST: "#989898",
  DARK_JUNGLE_GREEN: "#252525",
  SILKBLUE: "#428bca",
  BLACK: "#000000",
  DUNE: "#333333",
  PALERED: "#d9534f",
};

export const wrapper = css`
  width: 940px;
  margin: 0px auto;
  ${media.mobile_and_tablet`
      width: 100%;
    `}

  ${media.desktop`
      max-width: calc(100% - 202px);
    `}
`;

const miniReset = css`
  html {
    box-sizing: border-box;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  button,
  input {
    border: 0;
    padding: 0;
    color: inherit;
    background-color: inherit;
  }

  table {
    border-collapse: collapse;
  }
`;

/* eslint no-unused-expressions: 0 */
export default createGlobalStyle`


  body {
    margin: 0;
    padding: 0;
    font-family: neue-haas-unica, sans-serif;
    font-weight: 300;
    font-size: 14px;
    color: ${colors.DARK};
    height: 100%;
    overflow: hidden;

  }

  a,
  a:visited,
  a:hover,
  a:active { color: inherit; text-decoration: none; }
  a:focus { outline: none; }

 input::-webkit-input-placeholder { color: #B9C3C8; }
 input::-moz-placeholder {color: #B9C3C8 }
 input:-ms-input-placeholder {color: #B9C3C8 }
 input:-moz-placeholder {color: #B9C3C8 }
 input:-webkit-autofill { -webkit-box-shadow: 0 0 0 1000px ${colors.WHITE} inset; }

  #root {
    min-height: 100%;
    min-width: 100%;
  }

  button {
    cursor: pointer;
    padding: 2px 6px;
    font-weight: bold;
    font-size: 12px;
    font-family: poppins, sans-serif;
    text-align: center;
  }

  button:focus { outline: none; }

  ${miniReset}
`;
